import { BaseLayout } from "@components/layouts/base.layout";
import { USER_TYPE } from "@features/authentication";
import { lazy } from "react";
import RoleGuard from "../providers/role-guard.provider";
const AddOns = lazy(() => import("@/pages/power-ups"));
const Integrations = lazy(() => import("@pages/integrations"));
const SingleIntegration = lazy(
  () => import("@pages/integrations/components/single-integration"),
);

const PROFILE_ROUTES = {
  path: "profile",
  children: [
    {
      path: "integrations",
      element: (
        <BaseLayout title="Integrations">
          <Integrations />
        </BaseLayout>
      ),
    },
    {
      path: "integrations/gong",
      element: (
        <BaseLayout>
          <SingleIntegration />
        </BaseLayout>
      ),
    },
    {
      path: "integrations/salesforce",
      element: (
        <BaseLayout>
          <SingleIntegration />
        </BaseLayout>
      ),
    },
    {
      path: "integrations/salesforce/:sandbox",
      element: (
        <BaseLayout>
          <SingleIntegration />
        </BaseLayout>
      ),
    },
    {
      path: "integrations/hubspot",
      element: (
        <BaseLayout>
          <SingleIntegration />
        </BaseLayout>
      ),
    },
    {
      path: "integrations/fathom",
      element: (
        <BaseLayout>
          <SingleIntegration />
        </BaseLayout>
      ),
    },
    {
      path: "add-ons",
      element: (
        <RoleGuard
          notAllowed={[
            USER_TYPE.USER,
            USER_TYPE.CREATOR_LITE,
            USER_TYPE.CREATOR,
          ]}
        >
          <BaseLayout title="Power-ups">
            <AddOns />
          </BaseLayout>
        </RoleGuard>
      ),
    },
  ],
};

export default PROFILE_ROUTES;
